import React, { Component } from "react";
import patientImg from "../../assets/images/Patient.svg";
import opdIcon from "../../assets/images/Doctor.svg";
import radiologyIcon from "../../assets/images/Radiology.svg";
import { multipleUnits } from "../../schema/dashboard";
import DateRange from "../../components/FormComponent/DateRange";
import moment from "moment";
import { Tooltip, Spin, Select } from "antd";
import postService from "../../services/httpService";
import networkList from "../../constants/networkList";
import Storage from "./../../services/local-store";

const Option = Select.Option;
class Dashboard extends Component {
  state = {
    dateFrom: moment().format("YYYY-MM-DD"),
    dateTo: moment().format("YYYY-MM-DD"),
    titles: [
      {
        title: "Billing",
        class: "dashboardPatientDetails",
        titleclass: "cpdTitle",
        img: patientImg,
        data: "billing",
      },
      {
        title: "OPD Consultation",
        class: "dashboardOpd",
        titleclass: "opdTitle",
        img: opdIcon,
        data: "opd_consulting",
      },
      {
        title: "Radiology",
        class: "dashboardRadiology",
        titleclass: "radiologyTitle",
        img: radiologyIcon,
        data: "radiology",
      },
    ],
    cards: [
      { id: 1, key: "total_patients", label: "Total Patients" },
      { id: 2, key: "new_patients", label: "New Patients" },
      { id: 3, key: "old_patients", label: "Old Patients" },
      { id: 2, key: "planned_visits", label: "Planned Visits" },
      { id: 3, key: "unplanned_visits", label: "Un-Planned Visits" },
      { id: 4, key: "serviced", label: "Serviced" },
      { id: 5, key: "waiting", label: "Waiting" },
      { id: 6, key: "no_show", label: "No-Shows" },
      { key: "avg_waiting_time", label: "Avg Waiting Time" },
      { key: "avg_procedure_time", label: "Avg Procedure Time" },
      { id: 7, key: "total_skips", label: "Total Skips" },
    ],
    formData: null,
    data: {},
    activePage: 1,
    totalItemsCount: 0,
    isLoading: false,
    select2options: [],
    reportType: "",
    currentUnitId: null,
    currentUnitPlace: null,
    currentToken: null,
    currentUnitDetails:null
  };

  componentDidMount() {
    let current_Unit = Storage.get("current_Unit");
    let current_Unit_Details = current_Unit && JSON.parse(current_Unit);

    let allTokens = JSON.parse(Storage.get("all_tokens"));
    let storeToken = current_Unit_Details && current_Unit_Details.token ? current_Unit_Details.token :
      allTokens && allTokens[0] && allTokens[0].token
        ? allTokens[0].token
        : null;
    // storeToken && Storage.store("token", storeToken);

    let userData = JSON.parse(Storage.get("user_data"));
    // let unitid = current_Unit_Details && current_Unit_Details.unit_id ? current_Unit_Details.unit_id :
    //   allTokens && allTokens[0] && allTokens[0].unit_id
    //     ? allTokens[0].unit_id
    //     : null;
    // userData.unitid = unitid
    // let unitid = current_Unit_Details && current_Unit_Details.unit_id ? current_Unit_Details.unit_id :
    //               userData && userData.unitid ? userData.unitid : null;
    // userData.unitid = unitid
    // // Storage.store("user_data", userData);

    let unitid;
    if (current_Unit_Details && current_Unit_Details.unit_id) {
      unitid = current_Unit_Details.unit_id;
    } else if (userData && userData.unitid) {
      unitid = userData.unitid;
    } else {
      unitid = null;
    }
 
    // Now, you can safely set userData.unitid without encountering the mentioned error
    userData.unitid = unitid;
    
    let unitname = current_Unit_Details && current_Unit_Details.unit_name ? current_Unit_Details.unit_name :
      allTokens && allTokens[0] && allTokens[0].unit_name
        ? allTokens[0].unit_name
        : null;
    
    let displayname = current_Unit_Details && current_Unit_Details.display_name ? current_Unit_Details.display_name :
      allTokens && allTokens[0] && allTokens[0].display_name
        ? allTokens[0].display_name
        : null;
    // displayname && Storage.store("display_name", displayname);
    this.setState({currentUnitPlace:displayname})

    let obj = {
      unitid:unitid, unitname:unitname, displayname:displayname, token:storeToken
    }
    
    // console.log("CDM current_Unit_Details", current_Unit_Details);
    // console.log("CDM storeToken", storeToken);
    // console.log("CDM unitid", unitid);
    // console.log("CDM userData", userData);

    // Storage.store("current_Unit", obj) //hide
    this.setState({currentUnitDetails:obj}, () => {
      let unitsSchema = Object.assign({}, multipleUnits);
      unitsSchema["feilds"].map((feild, key) => {
        if (feild.name === "dashboardFilters") {
          unitsSchema["feilds"][key]["value"] = null;
          unitsSchema["feilds"][key]["visible"] = false;
        }
        if (feild.name === "unit_dashboard") {
          // unitsSchema["feilds"][key]["value"] = 1;
          unitsSchema["feilds"][key]["value"] = unitid
          unitsSchema["feilds"][key]["text"] = unitname
        } 
        unitsSchema["feilds"][key]["valid"] = false;
        unitsSchema["feilds"][key]["errors"] = [];
  
        delete unitsSchema["feilds"][key]["text"];
      });
      this.setState({ formData: unitsSchema["feilds"]}, () => this.fetchUnits());
    })

  }

  componentDidUpdate(prevProps, prevState) {
    const { select2options,currentUnitPlace, currentUnitDetails } = this.state;
    if(prevState.currentUnitPlace!==currentUnitPlace){
      this.props.setCurrentUnitPlace(currentUnitPlace)
    }
    if (prevState.select2options !== select2options) {
      select2options && this.fetchData();
      let unitsSchema;
      unitsSchema = Object.assign({}, multipleUnits);
      unitsSchema["feilds"].map((feild, key) => {
        // hide from
          // if (feild.name === "unit_dashboard") {
          //   unitsSchema["feilds"][key]["value"] = currentUnitDetails && currentUnitDetails.unitid ? currentUnitDetails.unitid :
          //     select2options && select2options[0].unit_id;
          //   unitsSchema["feilds"][key]["text"] = currentUnitDetails && currentUnitDetails.unitname ? currentUnitDetails.unitname : 
          //     select2options && select2options[0].unit_name;
          // }
          // hide to
          if (feild.name === "date") {
            unitsSchema["feilds"][key]["text"] =
              unitsSchema["feilds"][key]["value"];
          }
          unitsSchema["feilds"][key]["valid"] = false;
          unitsSchema["feilds"][key]["errors"] = [];

          // delete unitsSchema["feilds"][key]["text"];
      });
     this.setState({
        formData: unitsSchema["feilds"],
      });
    }
  }

  fetchUnits() {
    const { master_unit } = networkList;
    // this.setState({ isLoading: true });

    // Storage.store("token", res.token);
    let unitsArray = JSON.parse(Storage.get("all_tokens"));
    this.setState({
      select2options: unitsArray && unitsArray,
    });

    // await postService(master_unit, "GET", null).then((res) => {
    //   if (res) {
    //     this.setState((state) => ({
    //       select2options: res.data,
    //       isLoading: false,
    //     }));
    //   } else {
    //     this.setState({ isLoading: false });
    //   }
    // });
  }

  fetchData() {
    const { DashboardData } = networkList;
    const { dateTo, dateFrom, currentUnitDetails } = this.state;
    const obj = {
      unit_id: currentUnitDetails && currentUnitDetails.unitid ? currentUnitDetails.unitid : "",
      from_date: dateFrom ? moment(dateFrom).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      to_date: dateTo ? moment(dateTo).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
    };
    this.setState({ isLoading: true });

    postService(DashboardData, "POST", { data: obj }).then((res) => {
      if (res) {
        this.setState({ isLoading: false });
        if (res.status) {
          this.setState({ data: res.data });
        }
      }
    });
  }

  clearFilter = () => {
    try {
      this.setState(
        () => ({
          activePage: 1,
          totalItemsCount: 0,
          dateTo: moment().format("YYYY-MM-DD"),
          dateFrom: moment().format("YYYY-MM-DD"),
        }),
        () => {
          var formFeilds = this.state.formData;
          formFeilds.map((feild, key) => {
            if (feild.name === "unit_dashboard") {
              formFeilds[key]["value"] = null;
              formFeilds[key]["valid"] = false;
              formFeilds[key]["errors"] = [];
              formFeilds[key]["text"] = "Unit";
            }
          });
          this.setState({ formData: formFeilds });
          // this.loadPage();
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  // loadPage = () => {
  //   try {
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  editclick = (reporttype, dashboardFiltersId, dashboardFiltersText) => {
    var formFeilds = this.state.formData;
    if (formFeilds) {
      if (reporttype) {
        formFeilds[3]["value"] = reporttype;
        this.setState({ reportType: reporttype });
      }
      if (dashboardFiltersId && dashboardFiltersText) {
        formFeilds[2]["value"] = dashboardFiltersId;
        formFeilds[2]["text"] = dashboardFiltersText;
      }
    }
    // this.props.history.push("/settings/edit-user?rid=" + data["id"]);
    let report_type
    if(reporttype === "OPD Consultation"){
      report_type = "opd-consultation"
    }else if(reporttype === "Billing"){
      report_type = "billing"
    }else if(reporttype === "Radiology"){
      report_type = "radiology"
    }
    this.props.history.push("/dashboard/dashboard-details?from="+report_type);
  };

  handleChange(ele) {
  
    var formFeilds = this.state.formData;
    if (ele) {
      if (formFeilds) {
        if (ele.name === "date") {
          formFeilds[1]["value"] = ele.value;
          formFeilds[1]["text"] = ele.value;
          this.setState({
            dateFrom: ele.value[0],
            dateTo: ele.value[1],
          }, () => this.fetchData());
        } else {
          formFeilds[0]["value"] = ele.unit_id;
          formFeilds[0]["text"] = ele.unit_name;
          let obj = {
            unitid:ele.unit_id, unitname:ele.unit_name, displayname:ele.display_name , token: ele.token
          }
          // hide from
          // set unit id
          // let userData = JSON.parse(Storage.get("user_data"));
          // userData.unitid = ele.unit_id;
          // Storage.store("user_data", userData);
          // // set token
          // Storage.store("token", ele.token);
          // // set display_name
          // Storage.store("display_name", ele.display_name);
          // Storage.store("current_Unit", obj)
          // hide to
          this.setState({
            formData: formFeilds,
            selectedOption: ele.unit_name,
            currentUnitId: ele.unit_id,
            currentUnitPlace: ele.display_name,
            currentToken: ele.token,
            currentUnitDetails: obj
          }, () => this.fetchData());
        }
      }
    }
  

    // this.fetchData();
  }

  render() {
    var { select2options, selectedOption, currentUnitDetails } = this.state;
    var formFeilds = this.state.formData;
    const children = [];
    select2options.length &&
      select2options.map((data, key) => {
        if (data.unit_id !== null) {
          children.push(
            <Option
              key={key}
              value={data}
              // disabled={data.disabled ? data.disabled : false}
            >
              {data.unit_name && data.unit_name}
            </Option>
          );
        }
      });

    return (
      <Spin spinning={this.state.isLoading}>
        <div className="displaySpaceBetween">
          <div className="col-6 pl-4">
            <h3>Dashboard</h3>
          </div>
          {formFeilds &&
            formFeilds.map((feild, key) => {
              if (
                feild.element === "select2" &&
                feild.name === "unit_dashboard" &&
                feild.visible
              ) {
                return (
                  <div className="col-3">
                    {/* <Select2
                      Queuedata={feild}
                      selectdata={feild}
                      {...this.props}
                      {...this.state}
                      onselectChanges={this.handleChange.bind(this, feild)}
                    /> */}
                    {/* <Select
                      style={{
                        width: "100%",
                        height: "30px",
                      }}
                      value={currentUnitDetails && currentUnitDetails.unitname ? currentUnitDetails.unitname : 
                        selectedOption
                          ? selectedOption
                          : select2options.length
                          ? select2options[0].unit_name
                          : ""
                      }
                      onChange={this.handleChange.bind(this)}
                    >
                      {children}
                    </Select> */}
                  </div>
                );
              }
              if (feild.element === "daterange" && feild.visible) {
                return (
                  <div className="col-3" >                  
                    <DateRange
                      Queuedata={feild}
                      selectdata={feild}
                      {...this.props}
                      {...this.state}
                      // onselectChanges={(e) => {
                      //   this.setState({
                      //     dateFrom: e.value[0],
                      //     dateTo: e.value[1],
                      //   });
                      // }}
                      onselectChanges={this.handleChange.bind(this)}
                    />
                  </div>
                );
              }
            })}
        </div>
        <div className="row DashboardView">
          {/* <div>
        <h1 className="text-center" style={{ margin: "2%", color: "#94558a" }}>
          Welcome To QMS!
        </h1>
        <div className="row ">
          <div className="col text-center bg-white">
            <img
              alt=""
              src="../../assets/images/coming_soon.gif"
              style={{ height: "80%", width: "40%" }}
            />
          </div>
        </div> */}

          {this.state.titles.map((item) => (
            <div className="col-6">
              <div className={`dashboard ${item.class}`}>
                <img alt="" src={item.img} className="patientImg" />
                <span className={`titles ${item.titleclass}`}>
                  {item.title}
                </span>
                <div className="row ml-1">
                  {this.state.cards.map((detail) =>
                    item.title === "Billing"
                      ? detail["key"] !== "planned_visits" &&
                        detail["key"] !== "unplanned_visits" &&
                        (detail["key"] !== "avg_waiting_time" &&
                        detail["key"] !== "avg_procedure_time" ? (
                          <Tooltip title="Click to check">
                            <div
                              className="col dashboardCard"
                              onClick={this.editclick.bind(
                                this,
                                item.title,
                                detail["id"] && detail["id"],
                                detail["label"]
                              )}
                            >
                              <div className="dashboardCardDetails count">
                                {this.state.data[item.data] &&
                                  this.state.data[item.data][detail["key"]]}
                              </div>
                              <div className="dashboardCardDetails detail">
                                {detail["label"]}
                              </div>
                            </div>
                          </Tooltip>
                        ) : (
                          <div className="col dashboardCard">
                            <div className="count">
                              {this.state.data[item.data] &&
                                this.state.data[item.data][detail["key"]]}
                            </div>
                            <div className="detail">{detail["label"]}</div>
                          </div>
                        ))
                      : detail["key"] !== "new_patients" &&
                        detail["key"] !== "old_patients" &&
                        (detail["key"] !== "avg_waiting_time" &&
                        detail["key"] !== "avg_procedure_time" ? (
                          <Tooltip title="Click to check">
                            <div
                              className="col dashboardCard"
                              onClick={this.editclick.bind(
                                this,
                                item.title,
                                detail["id"] && detail["id"],
                                detail["label"]
                              )}
                            >
                              <div className="dashboardCardDetails count">
                                {this.state.data[item.data] &&
                                  this.state.data[item.data][detail["key"]]}
                              </div>
                              <div className="dashboardCardDetails detail">
                                {detail["label"]}
                              </div>
                            </div>
                          </Tooltip>
                        ) : (
                          <div className="col dashboardCard">
                            <div className="count">
                              {this.state.data[item.data] &&
                                this.state.data[item.data][detail["key"]]}
                            </div>
                            <div className="detail">{detail["label"]}</div>
                          </div>
                        ))
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Spin>
    );
  }
}

export default Dashboard;
